import React, { useState } from 'react'
import { SxProps, Theme } from '@mui/material/styles'
import Fab from '@mui/material/Fab'
import InputBase from '@mui/material/InputBase'
import Stack from '@mui/material/Stack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

export type ChatInputProps = {
  onSendMessage?: (message: string) => void
  sendIcon?: React.ReactElement
  sx?: SxProps<Theme>
}

const DefaultSendIcon = (
  <Fab size="small" color="primary" sx={{ m: '10px' }}>
    <ArrowForwardIcon />
  </Fab>
)

export function ChatInput(props: ChatInputProps) {
  const { onSendMessage, sendIcon = DefaultSendIcon, sx } = props
  const [message, setMessage] = useState<string>('')

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(event.target.value)
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const { key, shiftKey } = event

    if (key === 'Enter' && !shiftKey) {
      event.preventDefault()
      onSendMessage?.(message)
      setMessage('')
    }
  }

  const sendIconWithOnClick = React.cloneElement(sendIcon, {
    onClick: () => {
      onSendMessage?.(message)
      setMessage('')
    },
  })

  return (
    <Stack direction="row" alignItems="center" sx={sx}>
      <InputBase
        inputProps={{
          onKeyPress: handleKeyPress,
        }}
        maxRows={3}
        multiline
        onChange={handleChange}
        sx={{ ml: 1, flex: 1 }}
        value={message}
        data-testid="chat-input"
      />
      {sendIconWithOnClick}
    </Stack>
  )
}

export default ChatInput
